import React from 'react'
import { FormModal } from '@ztechapps/webui.form'
import { TemplateFormContent } from '../TemplateFormContent'
import { TriggerButton } from './TriggerButton'
import { useTemplateContext } from '../Context'
import { useManageTemplate } from '@ztechapps/common.hook'

export const AddTemplateFormModal = ({
  show,
  trigger = TriggerButton,
  initialValues,
  onAdd,
  onCancel,
  title = 'Add new template',
  container,
}) => {
  const { category, parentOnFilter } = useTemplateContext()
  const {
    initialValues: _initialValues,
    validate,
    onAddSubmit,
    onApply,
  } = useManageTemplate({ category, initialValues, onFilter: parentOnFilter })

  const onSubmit = async (e) => {
    await onAddSubmit(e)
    await onAdd?.(e)
  }

  return (
    <FormModal
      {...{
        show,
        trigger,
        initialValues: _initialValues,
        validate,
        onSubmit,
        onReset: onCancel,
        onHide: onCancel,
        title,
        onApply,
        container,
      }}
    >
      <TemplateFormContent />
    </FormModal>
  )
}
